import { useEffect, useState } from "react";
import client from "@/lib/api";
import { ORG_TYPES, OPPORTUNITY_TYPES, ACTION_TYPES, ACTION_SUBTYPES, ACTION_STATUSES } from "@/lib/constants";

const DEFAULTS = {
  org_types: ORG_TYPES,
  opportunity_types: OPPORTUNITY_TYPES,
  action_types: ACTION_TYPES,
  action_subtypes: ACTION_SUBTYPES,
  action_statuses: ACTION_STATUSES,
};

let cache = null;
let cacheAt = 0;
const fetchConfig = () => {
  if (!cache || Date.now() - cacheAt > 60000) {
    cacheAt = Date.now();
    cache = client.get("/config").then(({ data }) => ({ ...DEFAULTS, ...data })).catch(() => { cache = null; return DEFAULTS; });
  }
  return cache;
};

export const invalidateConfig = () => { cache = null; };

export function useConfig() {
  const [cfg, setCfg] = useState(DEFAULTS);
  useEffect(() => {
    let live = true;
    fetchConfig().then((c) => live && setCfg(c));
    return () => { live = false; };
  }, []);
  return cfg;
}
